export default {
  langEnglish: 'English',
  langRussian: 'Russian',
  langGerman: 'German',
  langChinese: 'Chinese',
  langUkraine: 'Ukrainian',
  changeLanguage: 'Change language',
}


// WEBPACK FOOTER //
// ./src/locale/en-US/account.js